import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
  blockSettings: { calendlyAccessToken: '' },

  activeItem: {},
};

export const appointmentSlice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    appointmentStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign, blockSettings } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };

      state.blockSettings = {
        calendlyAccessToken: blockSettings.calendlyAccessToken ?? '',
      };
    },
    appointmentClear: () => initialState,

    appointmentUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    appointmentUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    appointmentUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    appointmentUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    appointmentUpdateBlockSettings: (state, action) => {
      state.blockSettings = action.payload;
    },
    appointmentUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const {
  appointmentStore,
  appointmentClear,
  appointmentUpdateIsLoading,
  appointmentUpdateIsActive,
  appointmentUpdateBlockContent,
  appointmentUpdateBlockDesign,
  appointmentUpdateBlockSettings,
  appointmentUpdateActiveItem,
} = appointmentSlice.actions;

export const selectAppointmentIsLoading = (state) => state.appointment.isLoading;

export const selectAppointmentId = (state) => state.appointment.id;
export const selectAppointmentUID = (state) => state.appointment.uid;
export const selectAppointmentSID = (state) => state.appointment.sid;

export const selectAppointmentBlockContent = (state) => state.appointment.blockContent;
export const selectAppointmentBlockDesign = (state) => state.appointment.blockDesign;
export const selectAppointmentBlockSettings = (state) => state.appointment.blockSettings;
export const selectAppointmentSortItems = createSelector([selectAppointmentBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectAppointmentItemDesign = (state) => state.appointment.itemDesign;
export const selectAppointmentButtonDesign = (state) => state.appointment.buttonDesign;
export const selectAppointmentContainerDesign = (state) => state.appointment.containerDesign;

export const selectAppointmentActiveItem = (state) => state.appointment.activeItem;

export default appointmentSlice.reducer;
